import { render, staticRenderFns } from "./BasicQuill.vue?vue&type=template&id=bbe6bb88&scoped=true"
import script from "./BasicQuill.vue?vue&type=script&lang=js"
export * from "./BasicQuill.vue?vue&type=script&lang=js"
import style0 from "./BasicQuill.vue?vue&type=style&index=0&id=bbe6bb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe6bb88",
  null
  
)

export default component.exports